const Tips = ({className=""}) => {
    const gameTips = [
      "Les albums live ou best-of sortent souvent après la période de succès de l'artiste. Ne les place pas trop tôt.",
      "Les débuts de carrière sont souvent dans les années 90 ou 2000 pour les artistes actuels, évite de les mettre trop tard.",
      "Si tu vois un logo parental advisory bien visible, l'album est probablement post-1990.",
      "Un visuel pixelisé ou très minimaliste peut indiquer un album plus ancien, surtout pré-2000.",
      "Les photos en noir et blanc ou très granuleuses sont souvent associées aux années 60-70.",
      "Un featuring avec un artiste très jeune ou populaire peut aider à dater : vérifie leur époque.",
      "Les typographies très modernes ou géométriques sont plutôt des années 2010-2020.",
      "Une date précise d’un événement (genre Grammy Awards ou gros scandale) peut t’aider si tu la connais.",
      "Les premiers albums d’un groupe connu sont souvent sortis dans leurs jeunes années de carrière, logique mais facile à oublier.",
      "Certains albums sont sortis peu avant la mort d’un artiste : repère les légendes, ça aide à les situer chronologiquement.",
    ];
  
    const index = Math.floor(Math.random() * gameTips.length);
    const randomTip = gameTips[index];
  
    return (
      <p className={className}>{randomTip}</p>
    );
  };
  
  export default Tips;